module.exports = __webpack_public_path__ + "img/homerton_hs_b2.e595dd85.jpg";